import { createSelector } from '@ngrx/store';

import { profileNeedsOnboarding } from '../models/profile';
import { authFeature } from './auth.reducer';

export const {
  selectAuthState,
  selectReady,
  selectUserId,
  selectProfile,
  selectPasswordRecovery,
  selectPending,
  selectGooglePending,
} = authFeature;

export const selectIsAuthenticated = createSelector(
  selectUserId,
  (userId) => userId != null,
);

export const selectNeedsOnboarding = createSelector(selectProfile, (profile) =>
  profileNeedsOnboarding(profile),
);

export type AuthDestination =
  | '/login'
  | '/update-password'
  | '/onboarding'
  | '/';

export const selectAuthDestination = createSelector(
  selectReady,
  selectUserId,
  selectPasswordRecovery,
  selectNeedsOnboarding,
  (ready, userId, passwordRecovery, needsOnboarding): AuthDestination | null => {
    if (!ready) {
      return null;
    }
    if (!userId) {
      return '/login';
    }
    if (passwordRecovery) {
      return '/update-password';
    }
    if (needsOnboarding) {
      return '/onboarding';
    }
    return '/';
  },
);
